import React, { useState, useRef } from "react";
import { useSelector } from 'react-redux';
import { selectCurrentPlan } from '../../redux/selectors/authSelectors';
import { FEATURE_REQUIRED_PLANS } from '../../utils/planFeatureAccess';
import UpgradePromptModal from './UpgradePromptModal';

const CommentBox = ({ onSubmit, worker = false, placeholder = "Write a comment...", autoFocus = false }) => {
  const [comment, setComment] = useState("");
  const textareaRef = useRef(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const currentPlan = useSelector(selectCurrentPlan);

  const canComment = () => {
    const planLevels = {
      'trial': 0,
      'basic': 1,
      'premium': 2,
      'ultimate': 3
    };
    
    return planLevels[currentPlan] >= planLevels[FEATURE_REQUIRED_PLANS.commenting];
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canComment()) {
      setShowUpgradeModal(true);
      return;
    }
    if (comment.trim()) {
      onSubmit(comment);
      setComment("");
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    if (!canComment()) {
      setShowUpgradeModal(true);
      return;
    }
    if (comment.trim()) {
      onSubmit(comment);
      setComment("");
    }
  };

  // Focus textarea when autoFocus prop is true
  React.useEffect(() => {
    if (autoFocus && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className={`w-full flex flex-col items-end pr-3 border bg-white border-[#E9E9E9] ${
          worker ? "h-[100px]" : "h-[150px]"
        } rounded-[4px] ${!canComment() ? 'opacity-50' : ''}`}
      >
        <textarea
          ref={textareaRef}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={!canComment() ? "Upgrade to Premium to comment" : placeholder}
          className={`outline-none px-2 w-full py-2 text-sm border-none ${
            worker ? "h-[74px]" : "h-[150px]"
          } rounded-[4px] resize-none`}
          disabled={!canComment()}
        />
        <button
          onClick={handleButtonClick}
          type="submit"
          className={`text-sm font-semibold w-[81px] h-[32px] rounded-lg transition ${
            worker ? "-mt-[14px]" : "-mt-[40px]"
          } ${!canComment() ? 'bg-gray-400 text-white' : 'bg-[#F97316] text-white hover:bg-orange-600'}`}
        >
          Submit
        </button>
      </form>

      <UpgradePromptModal
        show={showUpgradeModal}
        handleClose={() => setShowUpgradeModal(false)}
        featureName="Commenting"
        requiredPlan="Premium"
      />
    </>
  );
};

export default CommentBox;
